var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.links)?_c('div',{staticClass:"m-0 p-0"},_vm._l((_vm.links),function(href,label){return _c('div',{key:("display-link__" + label)},[_c('a',{attrs:{"target":"_blank","href":href}},[_vm._v(_vm._s(label))])])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }